/*
 * @Author: czj
 * @Date: 2026-06-13 15:27:03
 * @Description: 数据加密解密工具函数
 * @FilePath: \kp-rag-system\src\utils\cryptoJS.js
 */
import CryptoJS from "crypto-js";

const KEY = CryptoJS.enc.Utf8.parse("CBRAININJURYATLA");
const IV = CryptoJS.enc.Utf8.parse("ALTAYRUJNINIARBC");

// 加密函数
export function encryptAES(text) {
  return CryptoJS.AES.encrypt(text, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString();
}
export function Aesencrypt(str) {
  var encrypted = CryptoJS.AES.encrypt(str, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

export function Aesdecrypt(str) {
  var decrypt = CryptoJS.AES.decrypt(str, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypt.toString(CryptoJS.enc.Utf8);
}
// 解密函数
export function decryptAES(cipher) {
  const bytes = CryptoJS.AES.decrypt(cipher, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return bytes.toString(CryptoJS.enc.Utf8);
}